import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "trigger"]

  connect() {
    this.hide()
  }

  show() {
    this.resetPosition()
    this.panelTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")

    requestAnimationFrame(() => this.keepInsideViewport())
  }

  hide() {
    this.panelTarget.querySelectorAll(":popover-open").forEach((panel) => panel.hidePopover())
    this.panelTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  toggle(event) {
    event.preventDefault()

    if (this.panelTarget.hidden) {
      this.show()
    } else {
      this.hide()
    }
  }

  hideIfOutside(event) {
    if (this.element.contains(event.target)) return

    this.hide()
  }

  resetPosition() {
    this.panelTarget.style.transform = ""
  }

  keepInsideViewport() {
    const padding = 12
    const rect = this.panelTarget.getBoundingClientRect()
    const viewportWidth = document.documentElement.clientWidth
    let offset = 0

    if (rect.right > viewportWidth - padding) {
      offset = viewportWidth - padding - rect.right
    } else if (rect.left < padding) {
      offset = padding - rect.left
    }

    if (offset !== 0) {
      this.panelTarget.style.transform = `translateX(${offset}px)`
    }
  }
}
